import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import Button from './Button';

const CopyButton = ({ text, className, variant = 'secondary', size = 16, iconOnly = false, label = 'Copy' }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!text) return;

        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const Icon = copied ? Check : Copy;

    if (iconOnly) {
        return (
            <button
                className={`icon-btn ${className || ''}`}
                onClick={handleCopy}
                title={copied ? "Copied!" : "Copy to clipboard"}
                style={{ color: copied ? '#10b981' : 'inherit', transition: 'color 0.2s' }}
            >
                <Icon size={size} />
            </button>
        );
    }

    return (
        <Button
            variant={variant}
            className={className}
            onClick={handleCopy}
            style={{ minWidth: '80px' }} // Prevent layout shift when text changes
        >
            <Icon size={size} style={{ marginRight: '0.5rem' }} />
            {copied ? 'Copied!' : label}
        </Button>
    );
};

export default CopyButton;
